<template>
  <div class="agency-label-warp wh-flex-center">
    <el-image
      :class="{'img-mini': !active, 'img-large': active}"
      :src="positionIcon"
      fit="fill"
    />
    <span
      class="agency-name"
      :class="{'txt-mini': !active, 'txt-large': active, 'active-name': active}"
    >
      {{ agencyName }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'AgencyLabel',
  props: {
    agencyName: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      positionIcon: require('./images/position-icon.png')
    }
  }
}
</script>

<style lang="less" scoped>
  .agency-label-warp{
    flex-direction: column;
    user-select: none;
    &:hover{
      cursor: pointer;
      .agency-name{
        color: #fdc223;
      }
    }
  }
  .active-name{
    color: #fdc223!important;
    font-weight: 600;
  }
  .img-mini{
    width: 20px;
    height: 20px
  }
  .img-middle{
    width: 40px;
    height: 40px
  }
  .img-large{
    width: 60px;
    height: 60px
  }
  .txt-mini{
    font-size: 12px;
    font-weight: bold;
  }
  .txt-large{
    font-size: 16px;
    font-weight: bold;
  }
</style>
